import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterSocial from './partials/FooterSocial';
import { Link } from 'react-router-dom';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-footer-inner',
            topDivider && 'has-top-divider'
          )}>
          {/* Top section with logo and social */}
          <div className="footer-top space-between text-xxs">
            <Logo />
            <FooterSocial />
          </div>
          
          {/* Enhanced footer content */}
          <div className="footer-enhanced-content">
            <div className="footer-enhanced-grid">
              {/* Downloads Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">Downloads</h4>
                <ul className="footer-section-list">
                  <li>
                    <Link to="/download-app" className="footer-link">
                      Desktop app
                    </Link>
                  </li>
                  <li>
                    <a 
                      href="https://chromewebstore.google.com/detail/luckynote/dgnamkhpffokcdhjnlebokmcgkkecncl" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      Chrome extension
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://apps.apple.com/us/app/luckynote-message-yourself/id1566320984" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      iPhone
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://play.google.com/store/apps/details?id=com.luckynote" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      Android
                    </a>
                  </li>
                  {/* <li>
                    <Link to="/web" className="footer-link">
                      Web app
                    </Link>
                  </li> */}
                </ul>
              </div>

              {/* Support Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">Support</h4>
                <ul className="footer-section-list">
                  <li>
                    <a 
                      href="https://tally.so/r/wM2WAp" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      Submit feedback
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://tally.so/r/w2YpLV" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      Report an issue
                    </a>
                  </li>
                  {/* <li>
                    <a 
                      href="https://help.luckynote.io" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      Help center
                    </a>
                  </li> */}
                  <li>
                    <a 
                      href="mailto:support@luckynote.io" 
                      className="footer-link"
                    >
                      Contact support
                    </a>
                  </li>
                  {/* <li>
                    <Link to="/faq" className="footer-link">
                      FAQ
                    </Link>
                  </li> */}
                </ul>
              </div>

              {/* About Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">About</h4>
                <ul className="footer-section-list">
                  <li>
                    <Link to="/about" className="footer-link">
                      About us
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog" className="footer-link">
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link to="/changelog" className="footer-link">
                      Changelog
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy" className="footer-link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-security" className="footer-link">
                      Data Security
                    </Link>
                  </li>
                  <li>
                    <Link to="/press" className="footer-link">
                      Press
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms" className="footer-link">
                      Terms of Service
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="footer-link">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Explore Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">Explore</h4>
                <ul className="footer-section-list">
                  <li>
                    <Link to="/use-cases/message-yourself" className="footer-link">
                      Message yourself
                    </Link>
                  </li>
                  <li>
                    <Link to="/use-cases/save-from-web" className="footer-link">
                      Save from the web
                    </Link>
                  </li>
                  <li>
                    <Link to="/compare" className="footer-link">
                      Compare
                    </Link>
                  </li>
                  <li>
                    <Link to="/for" className="footer-link">
                      Who it's for
                    </Link>
                  </li>
                  <li>
                    <Link to="/use-cases" className="footer-link">
                      Use cases
                    </Link>
                  </li>
                  <li>
                    <Link to="/message-yourself" className="footer-link">
                      Message yourself apps
                    </Link>
                  </li>
                  <li>
                    <Link to="/guides" className="footer-link">
                      Guides
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Community Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">Community</h4>
                <ul className="footer-section-list">
                  <li>
                    <a 
                      href="https://www.reddit.com/r/luckynote" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link footer-link-with-icon"
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.2047 8.53799C16.0117 8.53799 16.6667 9.19296 16.6667 9.99998C16.6667 10.5965 16.3041 11.1111 15.8246 11.345C15.848 11.4854 15.8597 11.6257 15.8597 11.7778C15.8597 14.0234 13.2515 15.8362 10.0234 15.8362C6.79533 15.8362 4.18714 14.0234 4.18714 11.7778C4.18714 11.6257 4.19884 11.4737 4.22223 11.3333C3.70761 11.0994 3.35673 10.5965 3.35673 9.99998C3.35673 9.19296 4.0117 8.53799 4.81872 8.53799C5.20468 8.53799 5.56726 8.70173 5.82457 8.94735C6.83041 8.21051 8.22223 7.75437 9.77778 7.70758L10.5146 4.2222C10.538 4.15203 10.5731 4.09355 10.6316 4.05846C10.6901 4.02337 10.7602 4.01168 10.8304 4.02337L13.2515 4.53799C13.4152 4.18711 13.7661 3.9532 14.1754 3.9532C14.7485 3.9532 15.2164 4.42103 15.2164 4.99413C15.2164 5.56723 14.7485 6.03507 14.1754 6.03507C13.614 6.03507 13.1579 5.59062 13.1345 5.04092L10.9708 4.58478L10.3041 7.70758C11.8246 7.76606 13.2047 8.2339 14.1988 8.94735C14.4561 8.69004 14.807 8.53799 15.2047 8.53799ZM7.70761 9.99998C7.13451 9.99998 6.66667 10.4678 6.66667 11.0409C6.66667 11.614 7.13451 12.0819 7.70761 12.0819C8.28071 12.0819 8.74854 11.614 8.74854 11.0409C8.74854 10.4678 8.28071 9.99998 7.70761 9.99998ZM10.0117 14.5497C10.4094 14.5497 11.7661 14.5029 12.4795 13.7895C12.5848 13.6842 12.5848 13.5204 12.5029 13.4035C12.3977 13.2982 12.2222 13.2982 12.117 13.4035C11.6608 13.8479 10.7135 14.0117 10.0234 14.0117C9.33334 14.0117 8.37427 13.8479 7.92983 13.4035C7.82457 13.2982 7.64913 13.2982 7.54386 13.4035C7.4386 13.5088 7.4386 13.6842 7.54386 13.7895C8.24562 14.4912 9.61404 14.5497 10.0117 14.5497ZM11.2515 11.0409C11.2515 11.614 11.7193 12.0819 12.2924 12.0819C12.8655 12.0819 13.3333 11.614 13.3333 11.0409C13.3333 10.4678 12.8655 9.99998 12.2924 9.99998C11.7193 9.99998 11.2515 10.4678 11.2515 11.0409Z" fill="currentColor"/>
                      </svg>
                      <span>r/luckynote</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://x.com/LuckynoteHQ" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link footer-link-with-icon"
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.2718 1.58643H18.0831L11.9413 8.606L19.1666 18.1581H13.5093L9.07828 12.3648L4.00821 18.1581H1.19528L7.76445 10.6498L0.833252 1.58643H6.63418L10.6394 6.8817L15.2718 1.58643ZM14.2852 16.4754H15.8429L5.78775 3.1807H4.11614L14.2852 16.4754Z" fill="currentColor"/>
                      </svg>
                      <span>@LuckynoteHQ</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.youtube.com/@luckynote" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="footer-link footer-link-with-icon"
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.8008 6C19.8008 6 19.6055 4.62109 19.0039 4.01563C18.2422 3.21875 17.3906 3.21484 17 3.16797C14.2031 2.96484 10.0039 2.96484 10.0039 2.96484H9.99609C9.99609 2.96484 5.79688 2.96484 3 3.16797C2.60938 3.21484 1.75781 3.21875 0.996094 4.01563C0.394531 4.62109 0.203125 6 0.203125 6C0.203125 6 0 7.62109 0 9.23828V10.7539C0 12.3711 0.199219 13.9922 0.199219 13.9922C0.199219 13.9922 0.394531 15.3711 0.992187 15.9766C1.75391 16.7734 2.75391 16.7461 3.19922 16.832C4.80078 16.9844 10 17.0313 10 17.0313C10 17.0313 14.2031 17.0234 17 16.8242C17.3906 16.7773 18.2422 16.7734 19.0039 15.9766C19.6055 15.3711 19.8008 13.9922 19.8008 13.9922C19.8008 13.9922 20 12.375 20 10.7539V9.23828C20 7.62109 19.8008 6 19.8008 6ZM7.93359 12.5938V6.97266L13.3359 9.79297L7.93359 12.5938Z" fill="currentColor"/>
                      </svg>
                      <span>@luckynote</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Featured on badges */}
          <div
            className="footer-bottom"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderTop: '1px solid rgba(20, 17, 15, 0.1)',
              paddingTop: '24px'
            }}
          >
            <div
              className="listmysaas-badge-embed"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem',
                maxWidth: '100%'
              }}
            >
              <a href="https://listmysaas.xyz/" target="_blank" rel="dofollow noopener">
                <img
                  src="https://listmysaas.xyz/listmysaasbadgenormal.svg"
                  alt="Featured on ListMySaaS"
                  width="125"
                  height="44"
                  loading="lazy"
                  decoding="async"
                />
              </a>
              <a href="https://www.tinyshelf.co/?ref=luckynote.io" title="Featured on tinyshelf" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://www.tinyshelf.co/badge/tinyshelf-badge-dark-f4d1216a.svg"
                  alt="Featured on tinyshelf"
                  width="216"
                  height="64"
                  loading="lazy"
                  decoding="async"
                />
              </a>
              <a href="https://tinylaunch.com" target="_blank" rel="noopener">
                <img
                  src="https://tinylaunch.com/tinylaunch_badge_1.svg"
                  alt="TinyLaunch Badge"
                  style={{
                    width: 202,
                    height: 'auto'
                  }}
                  loading="lazy"
                  decoding="async"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
